<template>
  <div ref="userGuiding"></div>
</template>

<script>
export default {
  name: 'UserGuiding',

  mounted() {
    const userCountry = localStorage.getItem('user_country')
    if (userCountry !== 'BR') return

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://static.userguiding.com/media/user-guiding-4TX114316H5FID-embedded.js'
    this.$refs.userGuiding.appendChild(script)
  },
}
</script>
